import React from 'react';
import { Card, Col, Row, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import blogData from '../data/blogdata'; // Adjust path if needed

const { Title, Paragraph, Text } = Typography;

const BlogList = () => {
  return (
    <div style={{ padding: '40px 20px', maxWidth: 1200, margin: '0 auto' }}>
      <Title level={2} style={{ textAlign: 'center', marginBottom: 40 }}>
        
      </Title>
      <Row gutter={[24, 24]}>
        {blogData.map((post) => (
          <Col key={post.id} xs={24} sm={12} md={8}>
            <Card
              hoverable
              cover={
                <img
                  alt={post.title}
                  src={post.imgUrl}
                  style={{ height: 200, objectFit: 'cover' }}
                />
              }
              style={{ borderRadius: 12 }}
            >
              <Title level={4}>{post.title}</Title>
              <Text type="secondary">
                By {post.author} • {post.date}
              </Text>
              <Paragraph ellipsis={{ rows: 3 }}>
                {post.description}
              </Paragraph>
              <Link to={`/blog/${post.id}`}>
                <Button type="primary" size="small">
                  Read More
                </Button>
              </Link>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default BlogList;
